import { request, RespError, handleFormatRes, date2TimestampStr } from '../../utils';
import { QRY_USER_QUAL_LOG_STAT } from '../../config/url';
/** 动作类型-枚举 */
export var QryUserQualLogStatOrderType;
(function (QryUserQualLogStatOrderType) {
    /** 派发 */
    QryUserQualLogStatOrderType[QryUserQualLogStatOrderType["DISPATCH"] = 1] = "DISPATCH";
    /** 兑换 */
    QryUserQualLogStatOrderType[QryUserQualLogStatOrderType["EXCHANGE"] = 2] = "EXCHANGE";
})(QryUserQualLogStatOrderType || (QryUserQualLogStatOrderType = {}));
/** 资格类型-枚举 */
export var QryUserQualLogStatQualTypeItem;
(function (QryUserQualLogStatQualTypeItem) {
    /** 印花 */
    QryUserQualLogStatQualTypeItem[QryUserQualLogStatQualTypeItem["STAMP"] = 1] = "STAMP";
    /** 优惠券-暂时还没用 */
    // COUPON = 2,
    /** 抽奖 */
    QryUserQualLogStatQualTypeItem[QryUserQualLogStatQualTypeItem["LOTTERY"] = 3] = "LOTTERY";
})(QryUserQualLogStatQualTypeItem || (QryUserQualLogStatQualTypeItem = {}));
// 需要转成 int 型的 key 数组
const needParseIntKey = ['times', 'count'];
// 需要转成 date 型的 key 数组
const needParseDateKey = [];
/**
 * 查询当前用户印花兑换统计
 * 接口地址：`/app/promotion/prom_qry_user_qual_log_stat.cgi`
 * https://iwiki.woa.com/pages/viewpage.action?pageId=1982480517
 * @param
 * @returns
 */
export async function qryUserQualLogStat({ qualId, qualTypeList, startTime, endTime, orderType, }) {
    try {
        // 参数格式化
        let params = {
            t: new Date().getTime(),
            qual_id: qualId,
            start_time: date2TimestampStr(startTime),
            end_time: date2TimestampStr(endTime),
            order_type: orderType,
        };
        if (qualTypeList) {
            params = Object.assign(Object.assign({}, params), { qual_type_list: qualTypeList.join('|') });
        }
        // 接口请求
        const result = await request.get(QRY_USER_QUAL_LOG_STAT, { params });
        if (result) {
            // 正常的返回
            if ((result === null || result === void 0 ? void 0 : result.retcode) === '0') {
                const res = handleFormatRes({ result, needParseIntKey, needParseDateKey });
                return res;
            }
            // 状态码错误的返回
            throw new RespError(result.retcode, result.retmsg, result);
        }
        throw result;
    }
    catch (error) {
        throw error;
    }
}
